module.exports = {"330824106":"桐村镇","330824107":"杨林镇","330824108":"苏庄镇","330824109":"齐溪镇","330824113":"村头镇","330824115":"华埠镇","330824116":"马金镇","330824117":"池淮镇","330824202":"中村乡","330824205":"长虹乡","330824208":"何田乡","330824216":"林山乡","330824217":"音坑乡","330824218":"大溪边乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330824.json
// module id = 1009
// module chunks = 0